export function removeAtIndex(arr: any[], id: string, index?: number) {
  const _index = index || arr.findIndex((item) => item === id);

  const newArray = arr.slice(); // 배열을 복사하여 원본 배열을 수정하지 않음
  newArray.splice(_index, 1); // 특정 인덱스에서 한 개의 요소를 제거
  return newArray;
}
